import { Link } from 'react-router-dom';
import { MapPin, Phone, Plus, Building2 } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * اختيار عنوان التوصيل من عناوين المستخدم المحفوظة (كروت قابلة للاختيار).
 */
const AddressPicker = ({ addresses, selectedId, onSelect, onAddNew }) => (
  <div>
    <div role="radiogroup" aria-label="عنوان التوصيل" className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
      {addresses.map((address) => {
        const selected = address.id === selectedId;
        return (
          <button
            key={address.id}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onSelect(address.id)}
            className={cn(
              'relative text-right rounded-2xl border-2 p-4 md:p-5 transition-all duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-burgundy-500/20',
              selected
                ? 'border-burgundy-500 bg-burgundy-500/[0.04] shadow-md shadow-burgundy-500/10'
                : 'border-gray-200 bg-white hover:border-burgundy-500/50 hover:shadow-sm'
            )}
          >
            <div className="flex items-start gap-3">
              <span
                className={cn(
                  'mt-0.5 shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors',
                  selected ? 'border-burgundy-500' : 'border-gray-300'
                )}
                aria-hidden="true"
              >
                <span className={cn('w-2.5 h-2.5 rounded-full bg-burgundy-500 transition-transform', selected ? 'scale-100' : 'scale-0')} />
              </span>

              <div className="flex-1 min-w-0 font-cairo">
                <div className="flex items-center justify-between gap-2 mb-1.5">
                  <p className="font-tajawal font-bold text-base md:text-lg text-brand-black flex items-center gap-1.5">
                    <MapPin className={cn('w-4 h-4 shrink-0', selected ? 'text-burgundy-500' : 'text-gray-400')} />
                    {address.city?.name || 'عنوان'}
                  </p>
                  {address.is_default && (
                    <span className="shrink-0 bg-gray-100 text-gray-600 text-[11px] px-2.5 py-0.5 rounded-full font-bold">أساسي</span>
                  )}
                </div>
                <p className="text-sm text-gray-700 break-words leading-relaxed">{address.street}</p>
                {address.building && (
                  <p className="text-xs text-gray-500 mt-1 flex items-center gap-1.5">
                    <Building2 className="w-3.5 h-3.5 shrink-0" /> {address.building}
                  </p>
                )}
                {address.phone && (
                  <p className="text-xs text-gray-500 mt-1 flex items-center gap-1.5">
                    <Phone className="w-3.5 h-3.5 shrink-0" /> <span dir="ltr">{address.phone}</span>
                  </p>
                )}
                {address.details && <p className="text-xs text-gray-400 mt-1.5 break-words">{address.details}</p>}
              </div>
            </div>

          </button>
        );
      })}

      <button
        type="button"
        onClick={onAddNew}
        className="min-h-[120px] rounded-2xl border-2 border-dashed border-gray-300 text-gray-500 hover:border-burgundy-500 hover:text-burgundy-500 hover:bg-burgundy-500/[0.03] transition-colors flex flex-col items-center justify-center gap-2 font-cairo font-semibold"
      >
        <span className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
          <Plus className="w-5 h-5" />
        </span>
        إضافة عنوان جديد
      </button>
    </div>

    <Link to="/account" className="inline-block mt-3 text-sm font-cairo text-gray-500 hover:text-burgundy-500 underline-offset-4 hover:underline">
      تعديل أو حذف العناوين من صفحة حسابي
    </Link>
  </div>
);

export default AddressPicker;
